import React from 'react';
import './ActionPanel.scss';

export const ActionPanel = ({ children, header }) => {
  return (
    <div className='action-panel'>
      {header && <div className='action-panel-header'>{header}</div>}
      {children}
    </div>
  );
};
